export const FTS_WEEKLY = 'ftsWeekly';

export const FTS_WEEKLY_ACTIONS_NAME = {
  searchTableData: `${FTS_WEEKLY}/searchTableData`,
  searchDeliveryTerms: `${FTS_WEEKLY}/searchDeliveryTerms`,
  searchTransportTypes: `${FTS_WEEKLY}/searchTransportTypes`,
  searchDeliveryGoodsPoints: `${FTS_WEEKLY}/searchDeliveryGoodsPoints`,
  searchExporters: `${FTS_WEEKLY}/searchExporters`,
} as const;

export const FTS_WEEKLY_MUTATIONS_NAME = {
  setTableData: `${FTS_WEEKLY}/setTableData`,
  setDeliveryTerms: `${FTS_WEEKLY}/setDeliveryTerms`,
  setTransportTypes: `${FTS_WEEKLY}/setTransportTypes`,
  setDeliveryGoodsPoints: `${FTS_WEEKLY}/setDeliveryGoodsPoints`,
  setExporters: `${FTS_WEEKLY}/setExporters`,
} as const;

export const FTS_WEEKLY_GETTERS_NAME = {
  getTableData: `${FTS_WEEKLY}/getTableData`,
  getDeliveryTerms: `${FTS_WEEKLY}/getDeliveryTerms`,
  getTransportTypes: `${FTS_WEEKLY}/getTransportTypes`,
  getDeliveryGoodsPoints: `${FTS_WEEKLY}/getDeliveryGoodsPoints`,
  getExporters: `${FTS_WEEKLY}/getExporters`,
} as const;
